import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { LeadService } from '../../leads/lead.service';

@Component({
  selector: 'app-mapleadfeld-agent',
  templateUrl: './mapleadfeld-agent.component.html',
  styleUrls: ['./mapleadfeld-agent.component.css']
})
export class MapleadfeldAgentComponent implements OnInit {


  @Input() data;
  public lastUploadid: number;
  headerValue: any = -1
  state: boolean;
  submitstate: boolean = false;
  procesedState: boolean;
  public alltemplate: any = [];
  public mapdata = [];
  public mapopt$ = new BehaviorSubject<any>([]);
  public mapopt = this.mapopt$.asObservable();
  form: FormGroup;
  selectedOptions = []
  selected = []
  select = []

  Header1: any = [];
  Header2: any = [];
  Header3: any = [];

  leadHeader = []
  _fileheader = []
  mappeddata = []

  template_name: string = ""
  public countheader: number = 0;
  public checkvalue: any = [];

  constructor(public activeModal: NgbActiveModal, protected router: Router, protected fb: FormBuilder, protected leadservice: LeadService) { }

  ngOnInit() {
    console.log(this.data);
    this.alltemplate = typeof this.data.leadfield != 'undefined' && this.data.leadfield && this.data.leadfield.length > 0 ? JSON.parse(this.data.leadfield) : []
    console.log("this.alltemplate::", this.alltemplate)
    console.log(this.selectedOptions)
    this.mapdata = typeof this.data.maphead != 'undefined' && this.data.maphead && this.data.maphead.length > 0 && this.data.maphead != 0 ? JSON.parse(this.data.maphead) : []  //JSON.parse(this.data.maphead.substring(1, this.data.maphead.length - 1)) || []  
    console.log(this.mapdata)

    let tmp: any = []

    let header1: any = []
    let header2: any = []
    let header3: any = []

    tmp = [];
    let tmp4: any = {};

    if (this.alltemplate.length > 0) {
      header1 = typeof this.alltemplate[0].fields != 'undefined' && this.alltemplate[0].fields ? this.alltemplate[0].fields : []
      header2 = typeof this.alltemplate[1].fields != 'undefined' && this.alltemplate[1].fields ? this.alltemplate[1].fields : []
      header3 = typeof this.alltemplate[2].fields != 'undefined' && this.alltemplate[2].fields ? this.alltemplate[2].fields : []

      this._fileheader = typeof this.data.fileheader != 'undefined' && this.data.fileheader ? JSON.parse(this.data.fileheader) : []

      console.log(header1);
      header1.forEach((ele: any) => {
        let foundlabel: boolean = false;
        this.mapdata.forEach((element) => {
          {
            if (element.crmfields == ele.fields) {
              console.log("carmlabel::" + element.crmfields + " == " + ele.fields);

              let currheader = (this._fileheader.indexOf(element.label)) + 1;
              tmp.push({
                crmfields: ele.crmfields,
                headermap: ele.headermap,
                selectable: false
              });
              if (ele.label != '') {
                this.Header1.push({
                  field: ele.fields,
                  label: ele.label,
                  headermap: currheader
                });
              }
              tmp4[ele.fields] = [element.crmfields];
              foundlabel = true;

              this.mappeddata.push({
                crmfields: element.crmfields,
                headermap: currheader,
                label: element.label
              });
            }
          }
        });
        if (!foundlabel && ele.label != '') {
          this.Header2.push({
            field: ele.fields,
            label: ele.label,
            headermap: 0
          });
          tmp.push({
            crmfields: ele.crmfields,
            headermap: ele.headermap,
            selectable: true
          })
          tmp4[ele.fields] = [];
        }
      });

      header2.forEach((ele: any) => {
        let foundlabel: boolean = false;
        this.mapdata.forEach((element) => {
          {
            if (element.crmfields == ele.fields) {
              console.log("carmlabel::" + element.crmfields + " == " + ele.fields);

              let currheader = (this._fileheader.indexOf(element.label)) + 1;
              tmp.push({
                crmfields: ele.crmfields,
                headermap: ele.headermap,
                selectable: false
              })
              if (ele.label != '') {
                this.Header3.push({
                  field: ele.fields,
                  label: ele.label,
                  headermap: currheader
                });
              }
              tmp4[ele.fields] = [element.crmfields];
              foundlabel = true;

              this.mappeddata.push({
                crmfields: element.crmfields,
                headermap: currheader,
                label: element.label
              });
            }
          }
        });
        if (!foundlabel && ele.label != '') {
          this.Header2.push({
            field: ele.fields,
            label: ele.label,
            headermap: 0
          });
          tmp.push({
            crmfields: ele.crmfields,
            headermap: ele.headermap,
            selectable: true
          });
          tmp4[ele.fields] = [];
        }
      });

      header3.forEach((ele: any) => {
        let foundlabel: boolean = false;
        this.mapdata.forEach((element) => {
          {
            if (element.crmfields == ele.fields) {
              console.log("carmlabel::" + element.crmfields + " == " + ele.fields);

              let currheader = (this._fileheader.indexOf(element.label)) + 1;
              tmp.push({
                crmfields: ele.crmfields,
                headermap: ele.headermap,
                selectable: false
              })
              if (ele.label != '') {
                this.Header1.push({
                  field: ele.fields,
                  label: ele.label,
                  headermap: currheader
                });
              }
              tmp4[ele.fields] = [element.crmfields];
              foundlabel = true;

              this.mappeddata.push({
                crmfields: element.crmfields,
                headermap: currheader,
                label: element.label
              });
            }
          }
        });
        if (!foundlabel && ele.label != '') {
          this.Header3.push({
            field: ele.fields,
            label: ele.label,
            headermap: 0
          });
          tmp.push({
            crmfields: ele.crmfields,
            headermap: ele.headermap,
            selectable: true
          })
          tmp4[ele.fields] = [];
        }
      });
      this.mapopt$.next(this.mapdata);
      this.form = this.fb.group(tmp4);
    }

    console.log("Header1::", header1)
    console.log("Header2::", header2)
    console.log("Header3::", header3)
    console.log("this.Header1::", this.Header1)
    console.log("this.Header2::", this.Header2)
    console.log("this.Header3::", this.Header3)
    console.log("fileheader data:::", this._fileheader)

    Object.entries(this._fileheader).forEach(([key, value]) => {
      console.log(key, value)
      this.leadHeader.push({
        'cols': value,
        'indcol': parseInt(key) + 1
      })
    })

    this.form = this.fb.group({
      lead_type: [''],
      agent_type: [''],
      assign_lead: [''],
      id_leadstatus: [''],
      first_name: [''],
      last_name: [''],
      birth_date: [''],
      age: [''],
      street_address_1: [''],
      street_address_2: [''],
      city: [''],
      state: [''],
      county: [''],
      zip: [''],
      phone: ['', Validators.required],
      cell_phone: [''],
      work_phone: [''],
      email: [''],
      height: [''],
      weight: [''],
      lender: [''],
      occupation: [''],
      smoker: [''],
      beneficiary: [''],
      status: [''],
      loan_amount: [''],
      assign_date: [''],
      salse_rep_name: [''],
      spouse_full_name: [''],
      spouse_age: [''],
      spouse_birth_date: [''],
      spouse_smoker: [''],
      spouse_height: [''],
      spouse_weight: [''],
      spouse_occupation: [''],
      purchase_refi: [''],
      home_value: [''],
      mortgage_term: [''],
      mortgage_amount: [''],
      monthly_mortage_payment: [''],
      health_issue: [''],
      spouse_health_issue: [''],
      referrer: [''],
      disposition: [''],
      comments: [''],
      didpick: [''],
      dispoattempts: [''],
      uploadstatus: [''],
      dispodate: [''],
      queued: [''],
      lead_level: [''],
      callback_time: [''],
      script_name: [''],
      script_body: [''],
      lead_field: [''],
      field1: [''],
      field2: [''],
      field3: [''],
      field4: [''],
      field5: [''],
      field6: [''],
      created_date: [''],
      event_tasks_id: [''],
      tag_id: [''],
      country: [''],
      hall: [''],
      bed_room: [''],
      guest_room: [''],
      bath_room: [''],
      drawing_room: [''],
      kitchen: [''],
      balcony: [''],
      dining_room: [''],
      library: [''],
      garage: [''],
      store_room: [''],
      swimming_pool: [''],
      laundry_room: [''],
      paintry_room: [''],
      home_office: [''],
      work_shop: [''],
      kids_room: [''],
      field7: [''],
      field8: [''],
      field9: [''],
      field10: [''],
      field11: [''],
      field12: [''],
      lead_script: ['']
    })
    this.headerValue = 0
  }

  setHeaderOption(column: any, fileheader: any, label: string, index: number) {
    fileheader = fileheader.target.value
    if (+fileheader != 0) {
      this.checkvalue.push(column)
    } else {
      this.checkvalue.splice(this.checkvalue.indexOf(column), 1);
    }
    this.countheader = +fileheader == 0 ? this.countheader - 1 : this.countheader + 1
    this.Header1.forEach(ele => {
      // console.log(ele.field + '==' + column)
      if (ele.field == column) {
        for (let i = 0; i < this.mappeddata.length; i++) {
          if (this.mappeddata[i].crmfields == column)
            this.mappeddata.splice(i, 1);
        }

        if (fileheader != -1) {
          let csv_label = this._fileheader[fileheader - 1];
          // console.log("Label:", csv_label);
          this.mappeddata.push({
            crmfields: column,
            headermap: fileheader,
            label: csv_label
          });
        }
      }
    })

    this.Header2.forEach(ele => {
      // console.log(ele.field + '==' + column)
      if (ele.field == column) {
        for (let i = 0; i < this.mappeddata.length; i++) {
          if (this.mappeddata[i].crmfields == column)
            this.mappeddata.splice(i, 1);
        }

        if (fileheader != -1) {
          let csv_label = this._fileheader[fileheader - 1];
          // console.log("Label:", csv_label);
          this.mappeddata.push({
            crmfields: column,
            headermap: fileheader,
            label: csv_label
          });
        }
      }
    })

    this.Header3.forEach(ele => {
      // console.log(ele.field + '==' + column)
      if (ele.field == column) {
        for (let i = 0; i < this.mappeddata.length; i++) {
          if (this.mappeddata[i].crmfields == column)
            this.mappeddata.splice(i, 1);
        }

        if (fileheader != -1) {
          let csv_label = this._fileheader[fileheader - 1];
          // console.log("Label:", csv_label);
          this.mappeddata.push({
            crmfields: column,
            headermap: fileheader,
            label: csv_label
          });
        }
      }
    })
    // console.log("this.mappeddata::", this.mappeddata)

    // let val = this.mapopt$.getValue();
    // let tmp = [];
    // this.mapdata.forEach(ele => {
    //   let foundlabel: boolean = false;
    //   val.forEach((element) => {
    //     if (ele.crmfields == element.crmfields) {
    //       tmp.push({ crmfields: ele.crmfields, headermap: ele.headermap, selectable: true });
    //       foundlabel = true;
    //     }
    //     else if (ele.crmfields == event.target.value) {
    //       tmp.push({ crmfields: ele.crmfields, headermap: ele.headermap, selectable: true });
    //       foundlabel = true;
    //     }
    //   });
    //   if (!foundlabel) {
    //     tmp.push({ crmfields: ele.crmfields, headermap: ele.headermap, selectable: false });
    //   }
    // });
  }
  onChange(e, i, value) {
    console.log('ttttttttrrrrr', value)
    let index = this.selectedOptions.findIndex((e: any) => e.id == value)
    if (index > -1)
      this.selectedOptions[index] = { id: value, value: parseInt(e) }
    else
      this.selectedOptions.push({ id: value, value: parseInt(e) })
    console.log(this.selectedOptions)

  }
  // onChange1(e,i,value){
  //   console.log(e,i,value)
  //   this.selectedOptions.push({id:value, value:parseInt(e)})
  //   console.log(this.selectedOptions)

  // }
  // onChange2(e,i,value){
  //   console.log(e,i,value)
  //   this.selectedOptions.push({id:value, value:parseInt(e)})
  //   console.log(this.selectedOptions)

  // }
  skipArray(nameKey: any, myArray: any) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i] === nameKey) {
        return 1;
      }
    }
  }

  // mapClose(sdata: any) {
  //   this.activeModal.close(sdata);
  //   console.log(sdata);
  // }

  onSubmitHeaderMapping() {
    if (['phone', 'cell_phone', 'work_phone'].some(value => this.checkvalue.includes(value))) {
      this.activeModal.close(JSON.stringify({
        uploads: this.data.uploads,
        saveheader: false,
        tempid: this.data.tempid,
        mapping_header: this.mappeddata,
        headerlen: this.leadHeader.length,
        template_name: this.template_name
      }));
    } else {
      alert('Please map atleast one field either phone Number or Cell Phone Number or work phone Number')
    }
  }

  onSubmitHeaderMappingSave() {
    if (['phone', 'cell_phone', 'work_phone'].some(value => this.checkvalue.includes(value))) {
      this.activeModal.close(JSON.stringify({
        uploads: this.data.uploads,
        saveheader: true,
        tempid: this.data.tempid,
        mapping_header: this.mappeddata,
        headerlen: this.leadHeader.length,
        template_name: this.template_name
      }));
    } else {
      alert('Please map atleast one field either phone Number or Cell Phone Number or work phone Number')
    }
  }

  checkDisable(value: any) {
    if (this.selectedOptions.filter(e => e.value === value).length > 0) {
      return true
    } else {
      return false
    }
  }

  cancelupload() {
    console.log('cancelupload uploads::', this.data.uploads)
    if (Array.isArray(this.data.uploads)) {
      this.data.uploads.forEach((u: any) => {
        this.leadservice.deleteUploadFile(u.id_upload).subscribe((res: any) => {
          console.log('deleted part', u.part_number, res);
        });
      });
    }
  }

}